export const SAVE_PRESET_DISABLED_TOOLTIP = "Select a source language first";
